/**
 * Utility function to handle adding a new contact to a field value
 * Handles both single contact fields (type 8) and contact list fields (type 9)
 * 
 * @param {Object} contact - The new contact object with an id property
 * @param {number} fieldId - The ID of the field to update
 * @param {Array} fields - Array of field objects to determine field type
 * @param {Object} formData - Current form data object
 * @param {Function} handleFieldChange - Function to update the field value
 */
export const handleNewContactForField = (contact, fieldId, fields, formData, handleFieldChange) => {
    if (!contact?.id || fieldId === null) {
        return;
    }

    // Find the field to determine its type
    const field = fields.find(f => f.id === fieldId);
    
    if (field) {
        if (field.field_id === 9) {
            // ContactList field - append to existing array
            const currentValue = formData[fieldId] || [];
            let currentIds = [];
            
            // Parse current value to ensure it's an array of IDs
            if (Array.isArray(currentValue)) {
                currentIds = currentValue.map(id => parseInt(id)).filter(id => !isNaN(id) && id > 0);
            } else if (typeof currentValue === 'string' && currentValue.trim()) {
                try {
                    const parsed = JSON.parse(currentValue);
                    currentIds = Array.isArray(parsed) ? parsed.map(id => parseInt(id)).filter(id => !isNaN(id) && id > 0) : [];
                } catch {
                    currentIds = currentValue.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id) && id > 0);
                }
            }
            
            // Add the new contact ID if it's not already in the array
            if (!currentIds.includes(contact.id)) {
                currentIds.push(contact.id);
            }
            
            handleFieldChange(fieldId, currentIds);
        } else {
            // Single contact field - replace value
            handleFieldChange(fieldId, contact.id);
        }
    } else {
        // Fallback - treat as single contact field
        handleFieldChange(fieldId, contact.id);
    }
};
